import { defineComponent as _defineComponent } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnFilterButtonTypePrefix',
    props: {
        type: {
            type: String,
        },
        shouldShowPrefix: {
            type: Boolean,
        }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        /**
         * Small icon of selected type for FilterButton. Supports only numeric types
         */
        const props = __props;
        const __returned__ = { props };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
